import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "flex align-items-center justify-content-center",
  style: {"min-height":"80vh"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold text-primary" }, "Change password", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-900 font-medium mb-2",
  for: "current"
}, "Current password", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-900 font-medium mb-2",
  for: "new"
}, "New password", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-900 font-medium mb-2",
  for: "confirm"
}, "Confirm new password", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PInputText = _resolveComponent("PInputText")!
  const _component_PButton = _resolveComponent("PButton")!
  const _component_PCard = _resolveComponent("PCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PCard, {
      class: "w-full",
      style: {"max-width":"28rem"}
    }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      subtitle: _withCtx(() => [
        (_ctx.forced)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "You must change your password before continuing."))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "Update your account password."))
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.doChange()), ["prevent"]))
        }, [
          _hoisted_5,
          _createVNode(_component_PInputText, {
            autocomplete: "current-password",
            class: "w-full mb-3",
            id: "current",
            type: "password",
            modelValue: _ctx.currentPassword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPassword) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_6,
          _createVNode(_component_PInputText, {
            autocomplete: "new-password",
            class: "w-full mb-3",
            id: "new",
            type: "password",
            modelValue: _ctx.newPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_7,
          _createVNode(_component_PInputText, {
            autocomplete: "new-password",
            class: "w-full mb-3",
            id: "confirm",
            type: "password",
            modelValue: _ctx.confirmPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_PButton, {
            loading: _ctx.loading,
            class: "p-button-raised w-full mt-2",
            label: "Update password",
            type: "submit"
          }, null, 8, ["loading"])
        ], 32)
      ]),
      _: 1
    })
  ]))
}